import { render, staticRenderFns } from "./DataScreen copy 2.vue?vue&type=template&id=7e7915cd&scoped=true"
import script from "./DataScreen copy 2.vue?vue&type=script&lang=js"
export * from "./DataScreen copy 2.vue?vue&type=script&lang=js"
import style0 from "./DataScreen copy 2.vue?vue&type=style&index=0&id=7e7915cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7915cd",
  null
  
)

export default component.exports